module.exports = __webpack_public_path__ + "media/images/ibjjf/safe-sport-1-95ab5c32d428471b819b44296e32f8a7.svg";